import { __rest } from "tslib";
import React from 'react';
import Content from './popover-content';
import Trigger from './popover-trigger';
import Portal from './popover-portal';
import { PopoverProvider } from './popover-context';
import usePopover from './use-popover';
const POPOVER_NAME = 'vulcanui-popover';
function Popover(props) {
    const { children } = props, restProps = __rest(props, ["children"]);
    const popoverProps = usePopover(restProps);
    return React.createElement(PopoverProvider, Object.assign({}, popoverProps), children);
}
Popover.displayName = 'Popover';
Popover.toString = () => `.${POPOVER_NAME}`;
Popover.Trigger = Trigger;
Popover.Content = Content;
Popover.Portal = Portal;
export default Popover;
//# sourceMappingURL=popover.js.map